(function () {
  // Track which full-size images we've already told the browser to fetch,
  // so we never kick off the same request twice.
  var warmed = new Set();

  // Preload a full-size image into the browser cache. On click the main
  // image simply points at this already-cached URL, so the swap is instant.
  function preload(url) {
    if (!url || warmed.has(url)) return;
    warmed.add(url);
    var img = new Image();
    img.decoding = 'async';
    img.src = url;
  }

  function warmGallery(galleryContainer) {
    galleryContainer.querySelectorAll('.testimonial--thumb').forEach(function (thumb) {
      preload(thumb.getAttribute('data-src'));
    });
  }

  function swapMainImage(galleryContainer, thumbnail) {
    var dataSrc = thumbnail.getAttribute('data-src');
    var box = galleryContainer.querySelector('.js-testimonial-image');
    var mainImage = box && box.querySelector('img');
    if (!box || !mainImage || !dataSrc) return;
    if (mainImage.getAttribute('srcset') === dataSrc) return;

    // Cross-fade: stack the new image on top of the current one, fade it in,
    // then commit it to the base <img> and drop the layer.
    var layer = new Image();
    layer.className = 'testimonial--crossfade-layer';
    layer.decoding = 'async';
    layer.srcset = dataSrc;
    layer.src = dataSrc;

    var done = false;
    var commit = function () {
      if (done) return;
      done = true;
      mainImage.setAttribute('srcset', dataSrc);
      mainImage.setAttribute('src', dataSrc);
      requestAnimationFrame(function () {
        if (layer.parentNode) layer.parentNode.removeChild(layer);
      });
    };

    var reveal = function () {
      box.appendChild(layer);
      // Two frames so the browser registers the starting opacity before transitioning.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { layer.classList.add('is-visible'); });
      });
      layer.addEventListener('transitionend', commit, { once: true });
      setTimeout(commit, 600); // fallback if transitionend doesn't fire
    };

    // The full image is usually already cached (preloaded), so decode is instant.
    if (layer.decode) {
      layer.decode().then(reveal).catch(reveal);
    } else {
      reveal();
    }
  }

  function initGallery(galleryContainer) {
    // Guard against binding the same gallery more than once (shopify:section:load
    // fires for the whole document, not just the reloaded section).
    if (galleryContainer.dataset.galleryBound === '1') return;
    galleryContainer.dataset.galleryBound = '1';

    // Prefetch on intent — as soon as the user hovers, focuses or touches a
    // thumbnail, start fetching its full-size image so the click is instant.
    var prefetchFromEvent = function (event) {
      var thumb = event.target.closest('.testimonial--thumb');
      if (thumb) preload(thumb.getAttribute('data-src'));
    };
    galleryContainer.addEventListener('pointerover', prefetchFromEvent);
    galleryContainer.addEventListener('focusin', prefetchFromEvent);
    galleryContainer.addEventListener('touchstart', prefetchFromEvent, { passive: true });

    galleryContainer.addEventListener('click', function (event) {
      var thumbnail = event.target.closest('.testimonial--thumb');
      if (!thumbnail) return;
      event.preventDefault();
      swapMainImage(galleryContainer, thumbnail);
    });

    // Warm every thumbnail's full-size image during idle time so taps on
    // touch devices (which can't hover) are instant too.
    var warm = function () { warmGallery(galleryContainer); };
    if ('requestIdleCallback' in window) {
      requestIdleCallback(warm, { timeout: 2000 });
    } else {
      setTimeout(warm, 500);
    }
  }

  function initializeGallery() {
    document.querySelectorAll('.testimonial--item_image').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeGallery);
  } else {
    initializeGallery();
  }

  document.addEventListener('shopify:section:load', initializeGallery);
})();
